import {internalApi} from "../../../common/axios";
import {useQueryBase} from "../../../shared/hooks/useHookBase";
import toast from "react-hot-toast";

const fetchMergeEventMasterData = async () => {
    const {data} = await internalApi.get(`merge_event_master`);
    return data.rows;
}

export const useMergeEventMasterData = () => {
    return useQueryBase(['mergeEventMasterData'], fetchMergeEventMasterData, {staleTime: 0});
}

export const saveMergeEventMaster = async (data) => {
    try {
        const res = await internalApi.post('merge_event_master', {data});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const deleteMergeEventMaster = async (seq) => {
    try {
        const res = await internalApi.delete(`merge_event_master/${seq}`);
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("삭제 실패");
    }
}
